import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useLinkedToIndependent from 'hooks/athlete/connected/useLinkedToIndependent';
import { ConnectedAthlete } from 'types';
import notificationHandler from 'utils/notifications';

interface IDisconnectProfileModalProps {
  athlete: ConnectedAthlete | null;
  opened: boolean;
  closeHandler: () => void;
}

const DisconnectProfileModal = ({
  athlete,
  opened,
  closeHandler,
}: IDisconnectProfileModalProps): JSX.Element => {
  const { successNotification, errorNotification, infoNotification } = notificationHandler();
  const disconnectProfile = useLinkedToIndependent();

  const handleDelete = (): void => {
    disconnectProfile.mutate(athlete?.athleteId || '', {
      onSuccess: () => {
        successNotification('Profile disconnected successfully');
        infoNotification(
          'Payment method cleared',
          'Any active packages or unpaid invoices have been set to Unknown payment method. Please collect a new default payment method for this athlete.',
          false,
        );
        closeHandler();
      },
      onError: (e: any) => {
        errorNotification(`Something went wrong: ${e?.response?.data?.message}`);
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>Disconnect Profile?</Title>}
      size='lg'
      trapFocus
      centered
    >
      <Stack>
        <Text color='red'>{`Warning! The selected athlete will no longer have access to the primary profile's payment methods.`}</Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={disconnectProfile.isLoading}
            data-cy='disconnectContinue'
          >
            Continue
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default DisconnectProfileModal;
